import { AddButton as Button } from "../../add-button"

/**
 * Prepends a button to node.element if it qualifies as a merging node.
 *
 * @param node {object} data of individual node from Workflow::Graph.as_json
 * @return node {object} with node.element having a button prepended if applicable
 */
const renderMergeButton = node => {
  const sources = node.element.dataset.sources
  const hasSiblings = node.siblings && node.siblings.length > 0
  const childOfCondition = node.sourceNodes.every(
    node => node.kind == "condition"
  )

  if (
    node.kind == "empty" ||
    node.element.dataset.root == "true" ||
    (childOfCondition && hasSiblings) ||
    (!childOfCondition && !sources) ||
    (!childOfCondition && sources.split(" ").length <= 1)
  ) {
    return node
  }

  const mergeButton = new Button()

  mergeButton.dataset.type = "merge"

  node.element.prependContent(mergeButton)

  return node
}

/**
 * Iterates over an array of JSON nodes produced from Workflow::Graph.as_json
 * and returns them modified with a Button above them if they qualify as merging
 * nodes. data.nodes must first be precessed by `renderNodes` to ensure they
 * have been prepared for DOM manipulation.
 *
 * @param data {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: null }
 * @return {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: null }
 */
export const renderMergeButtons = data => {
  const nodes = data.nodes.map(renderMergeButton)

  return {
    ...data,
    nodes: nodes
  }
}

